import { render, staticRenderFns } from "./DateElement.vue?vue&type=template&id=f097b3ea&"
import script from "./DateElement.vue?vue&type=script&lang=js&"
export * from "./DateElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports